import { Box, IconButton, Typography, useTheme } from '@mui/material';
import { useRef, useState } from 'react';
import { ReactComponent as CloseIcon } from '../assets/icons/main/close-icon.svg';

const styles = {
  container: {
    width: '100%',
    maxWidth: '100%',
    border: '1px solid',
    borderRadius: '8px',
    height: '110px',
    boxSizing: 'border-box',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    padding: '16px',
    cursor: 'pointer',
  },
  text: {
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '26px',
  },
  linkText: {
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '26px',
  },
  helperText: {
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '26px',
  },
  fileName: {
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '26px',
    marginTop: '8px',
    wordBreak: 'break-word',
  },
  fileNameRow: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    marginTop: '8px',
  },
  clearButton: {
    width: '22px',
    height: '22px',
    padding: 0,
  },
};

const FileUploadDropZone = ({
  accept = '.xlsx,.xls,.csv',
  helperText = '(Import Excel / CSV file)',
  onFileSelect = () => { },
}: any) => {
  const themeData = useTheme();
  const inputRef = useRef<HTMLInputElement | null>(null);
  const [isDragging, setIsDragging] = useState(false);
  const [selectedFileName, setSelectedFileName] = useState('');

  const handleFile = (file?: File) => {
    if (!file) {
      return;
    }

    setSelectedFileName(file.name);
    onFileSelect(file);
  };

  const openFilePicker = () => {
    inputRef.current?.click();
  };

  const clearSelectedFile = (event: React.MouseEvent) => {
    event.stopPropagation();
    setSelectedFileName('');
    if (inputRef.current) {
      inputRef.current.value = '';
    }
    onFileSelect(null);
  };

  return (
    <Box>
      <Box
        sx={{
          ...styles.container,
          border: '1px solid #D9DFEDCC',
          backgroundColor: '#F8FAFB',
        }}
        onClick={openFilePicker}
        onDragOver={(event) => {
          event.preventDefault();
          setIsDragging(true);
        }}
        onDragLeave={() => setIsDragging(false)}
        onDrop={(event) => {
          event.preventDefault();
          setIsDragging(false);
          handleFile(event.dataTransfer.files?.[0]);
        }}
      >
        <Box>
          {!selectedFileName ? (
            <>
              <Typography sx={{ ...styles.text, color: themeData.palette.text.secondary }}>
                Drag & drop file here
              </Typography>
              <Typography sx={{ ...styles.text, color: themeData.palette.text.secondary }}>
                or <Box component='span' sx={{ ...styles.linkText, color: themeData.palette.primary.main }}>browse</Box> file from device
              </Typography>
              <Typography sx={{ ...styles.helperText, color: themeData.palette.text.secondary }}>{helperText}</Typography>
            </>
          ) : (
            <Box sx={styles.fileNameRow}>
              <Typography sx={{ ...styles.fileName, color: themeData.palette.text.primary, marginTop: 0 }}>
                Selected file: {selectedFileName}
              </Typography>
              <IconButton sx={styles.clearButton} onClick={clearSelectedFile}>
                <CloseIcon style={{ color: themeData.palette.text.secondary, width: '14px', height: '14px' }} />
              </IconButton>
            </Box>
          )}
        </Box>
      </Box>
      <input
        ref={inputRef}
        type='file'
        accept={accept}
        style={{ display: 'none' }}
        onChange={(event) => handleFile(event.target.files?.[0])}
      />
    </Box>
  );
};

export default FileUploadDropZone;